import React from 'react'
import { useMediaQuery } from 'react-responsive'
 
export const Responsive = (props) => {
    const queries = {
        'big-screen': useMediaQuery({ minWidth: 1920 }),
        'desktop': useMediaQuery({ minWidth: 992 }),
        'tablet': useMediaQuery({ minWidth: 768, maxWidth: 991 }),
        'mobile': useMediaQuery({ maxWidth: 767 })
    };

    for(var key in queries){
        if(typeof props[key] !== 'undefined' && props[key] && queries[key])
            return props.children;
    }

    return null;
}